import {
  actionCreator,
  checkHttpStatus,
  GET_USER_ROLES_LIST_API,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  UserRoleActionTypes,
  DELETE_USER_ROLE_API,
  POST_USER_ROLE_API,
  GET_USER_ROLE_DETAILS_API,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../actions/utilAction';


export const getUserRoleList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(UserRoleActionTypes.get_userRolesList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_USER_ROLES_LIST_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(UserRoleActionTypes.get_userRolesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(UserRoleActionTypes.get_userRolesList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_userRolesList ', error);
      });
  };
};

export const saveUserRoles = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(UserRoleActionTypes.post_userRole.REQUEST));
    fetch(POST_USER_ROLE_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(UserRoleActionTypes.post_userRole.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(UserRoleActionTypes.post_userRole.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_userRole', error);
      });
  };
};

export const getUserRoleDetails = (RoleID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(UserRoleActionTypes.get_userRoleDetails.REQUEST));
    fetch(`${GET_USER_ROLE_DETAILS_API}?id=${RoleID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(UserRoleActionTypes.get_userRoleDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(UserRoleActionTypes.get_userRoleDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_userRoleDetails ', error);
      });
  };
};

// delete UserRoles ...
export const deleteUserRole = (RoleID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(UserRoleActionTypes.delete_userRole.REQUEST));
    fetch(`${DELETE_USER_ROLE_API}?id=${RoleID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(UserRoleActionTypes.delete_userRole.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(UserRoleActionTypes.delete_userRole.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(UserRoleActionTypes.delete_userRole.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_userRole', error);
      });
  };
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/actions/UserRoleActions.js